import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0544c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "剪贴板信息", -1))
const _hoisted_2 = { class: "clipboardLoadMore" }
const _hoisted_3 = { key: 1 }

import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { ElMessage } from 'element-plus'
import { ClipboardGetters, ClipboardActions, ClipboardMutations } from '@/store/modules/clipboard';
import { baseUrl } from "@/requests";


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "ClipboardWindow",
});

interface TimeLineNode {
    content: string,
    timeToDisplay: string,
    timestamp: string,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const clipTable = ref<HTMLElement | null>(null);


const route = useRoute();
const store = useStore();

const timeLineSlice = ref<TimeLineNode[]>([])
const nowTimeNode = ref<string>("")
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const popoverVisible = ref<boolean>(false)

const isLoading = computed(() => {
    return store.getters[`clipboard/${ClipboardGetters.getLoading}`]
});
const clipboardList = computed(() => {
    return store.getters[`clipboard/${ClipboardGetters.getClipboardList}`]
});
const isAllLoaded = computed(() => {
    return store.getters[`clipboard/${ClipboardGetters.getIsAllLoaded}`]
});
const times = computed(() => {
    return store.getters[`clipboard/${ClipboardGetters.getTimeLineSlice}`]
});

const copyText = (content: string): void => {
    try {
        let oInput = document.createElement('input');
        oInput.value = content;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand("Copy");
        oInput.style.display = 'none';
        ElMessage({
            message: '复制成功',
            type: 'success',
        })
    } catch (err) {
        console.log(err)
    }
}

// const getClipboardList = (dataIn: string): ClipboardInfo[] => {
//     if (dataIn == undefined) {
//         return [];
//     } else {
//         let msgList: string[] = dataIn.split('[+] ');
//         return msgList.slice(1).map(
//             (clipboardMsg: string) => {
//                 let clipboardSplit = clipboardMsg.split(':')
//                 return {
//                     time: clipboardSplit.slice(0, 3).join(':'),
//                     content: clipboardSplit.slice(3,).join(':'),
//                 }
//             }
//         );
//     }
// }

const handleChooseTime = async (time: string) => {
    nowTimeNode.value = time
    store.commit(`clipboard/${ClipboardMutations.resetAll}`);
    await store.dispatch(`clipboard/${ClipboardActions.asyncGetClipboardListByTime}`, { projId: projectId.value, uid: targetId.value, time })
}

const loadMore = async () => {
    if (!isLoading.value && !isAllLoaded.value && nowTimeNode.value !== "") {
        const projId = projectId.value
        const uid = targetId.value;
        await store.dispatch(`clipboard/${ClipboardActions.asyncGetClipboardListByTime}`, { projId: projectId.value, uid: targetId.value, time: nowTimeNode.value })
    }
}

const getTimeLine = (data: string[]) => {
    for (let i = 0; i < data.length; i++) {
        timeLineSlice.value.push({
            content: data[i],
            timeToDisplay: getDisplayTime(data[i]),
            timestamp: data[i]
        })
    }
}
const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}
onMounted(async () => {
    const projId = projectId.value
    const uid = targetId.value;
    await store.dispatch(`clipboard/${ClipboardActions.asyncGetTimeLine}`, { projId: projectId.value, uid: targetId.value })
    if (times.value.length !== 0) {
        await store.dispatch(`clipboard/${ClipboardActions.asyncGetClipboardListByTime}`, { projId: projectId.value, uid: targetId.value, time: times.value[0] })
        nowTimeNode.value = times.value[0]
        getTimeLine(times.value)
    }
    // 暂时做了一个reduce把所有clipboard都取出来了 关于去重或者timeline之后商量以后再弄
    // clipboardState.value.clipboardList = res.reduce(
    //     (acc, cur) => acc.concat(getClipboardList(cur.clipboardInfo)),
    //     [] as ClipboardInfo[]
    // );
    // clipboardState.value.clipboardList = getClipboardList(res);
})

onUnmounted(() => {
    store.commit(`clipboard/${ClipboardMutations.resetAll}`);
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_timeline, { class: "TimeLinePopover" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineSlice.value, (timeNode, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: timeNode.timeToDisplay,
                  onClick: ($event: any) => (handleChooseTime(timeNode.timestamp)),
                  type: timeNode.timestamp === nowTimeNode.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(timeNode.timeToDisplay), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp", "onClick", "type"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_1,
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref_key: "clipTable",
      ref: clipTable,
      class: "clipboardWindowContainer"
    }, [
      (_unref(clipboardList).length != 0)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _unref(clipboardList),
            stripe: "",
            style: {"width":"100%","height":"100%"}
          }, {
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (!_unref(isAllLoaded))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      link: "",
                      type: "primary",
                      disabled: _unref(isLoading),
                      onClick: loadMore
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 加载更多 ")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_unref(isAllLoaded))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, "------已加载全部-------"))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "copyTime",
                label: "时间",
                width: "180"
              }),
              _createVNode(_component_el_table_column, { label: "内容" }, {
                default: _withCtx((scope) => [
                  (scope.row.infoType === 'Picture')
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        style: {"width":"50px","height":"50px"},
                        src: scope.row.download_status === 6 && scope.row.ossLink !== '' ? scope.row.ossLink : _unref(baseUrl) + '/' + scope.row.copyContent,
                        title: "点击查看大图",
                        "preview-src-list": [scope.row.download_status === 6 && scope.row.ossLink !== '' ? scope.row.ossLink : _unref(baseUrl) + '/' + scope.row.copyContent],
                        "preview-teleported": true
                      }, null, 8, ["src", "preview-src-list"]))
                    : (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.copyContent), 1)
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.infoType !== 'Picture')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        link: "",
                        onClick: ($event: any) => (copyText(scope.row.copyContent))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("复制")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            "image-size": 200
          }))
    ])), [
      [_directive_loading, _unref(isLoading)]
    ])
  ], 64))
}
}

})